export const faqpage = [
    {
        id: 1,
        question: "What is the Flow 7 system, and how does it help my practice?",
        answer:
            "The Flow 7 system tests for autonomic neuropathy and vascular issues. It uses three devices that are integrated. It helps detect issues early, enabling timely interventions for better patient outcomes.",
    },
    {
        id: 2,
        question: "How does the placental graft solution work for wound care?",
        answer:
            "Our placental graft solution uses growth factors. They speed up the healing of chronic wounds. These are wounds that haven't healed after 30 days of standard treatments. It’s an ethical, effective solution with support for reimbursement.",
    },
    {
        id: 3,
        question: "Can I offer MITSI in-house lab services at my practice?",
        answer:
            "Yes! MITSI provides everything to set up a compliant in-house lab. This includes equipment, staff training, and ongoing support. You’ll be able to perform diagnostics without relying on third-party labs.",
    },
    {
        id: 4,
        question: "What types of conditions can neurofeedback treat?",
        answer:
            "Brain waves are crucial for mental wellness. Neurofeedback can rebalance these waves. This method helps people with ADHD, PTSD, anxiety, depression, chronic pain, and brain injuries. It unlocks the brain's healing power, improving mental health and resilience.",
    },
    {
        id: 5,
        question: "What types of allergy testing does MITSI offer?",
        answer:
            "Quickly find allergens with our 72-prick test. Get fast, accurate results. Then, we create personalized plans to reduce reactions and ease symptoms. MITSI helps you overcome allergies and regain comfort.",
    },
    {
        id: 6,
        question: "How does MITSI ensure regulatory compliance for in-house labs?",
        answer:
            "MITSI ensures your in-house lab meets all necessary regulatory standards. We handle certification, inventory, and compliance with state and federal guidelines. So, your practice can focus on patient care.",
    },
    {
        id: 7,
        question: "What is the Brain Zen Pro program?",
        answer:
            "Brain Zen Pro is a neurofeedback program. It treats ADHD, PTSD, and autism. It improves brain function and supports recovery. There are no upfront costs for your practice.",
    },
    {
        id: 8,
        question: "Can I integrate MITSI with my existing practice management software?",
        answer:
            "Yes, MITSI will integrate with your existing systems. They will enable smooth operations for diagnostics, billing, and patient management.",
    },
    {
        id: 9,
        question: "What equipment is included in the Mini C-Arm service?",
        answer:
            "The Mini C-arm is a compact, portable tool. It images to help with precise osteoarthritis knee injections. It ensures clear visuals and exact needle placement. This improves patient outcomes and reduces discomfort.",
    },
    {
        id: 10,
        question: "Is there training available for using MITSI?",
        answer:
            "Yes, MITSI provides full training for all services, including neurofeedback, in -house labs, and diagnostic equipment.Our expert team ensures your staff can use the technology well.",
    },
];
